import { defineComponent as _defineComponent } from 'vue'
import { PartnerTrade, CommissionDisplayType, HedgingInstruments } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { computed } from 'vue';
import FundingTypeCell from '../tableCells/FundingTypeCell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeReportInfoDetails',
  props: {
    tradeReport: null,
    rejectedOrCanceled: { type: Boolean, default: false },
    displayType: { default: CommissionDisplayType.ORIGINAL }
  },
  setup(__props: any) {

const props = __props as { tradeReport: PartnerTrade, rejectedOrCanceled: boolean, displayType: CommissionDisplayType };



const isApportioned = computed(() => {
  return props.displayType === CommissionDisplayType.APPORTIONED;
});

const isVanillaOptions = computed(() => {
  return props.tradeReport.hedgingProduct === HedgingInstruments.VANILLA_OPTIONS;
});

return { __sfc: true,props, isApportioned, isVanillaOptions, formatCurrencyValue, formatDate, FundingTypeCell }
}

})